var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiyoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15L15.69 12L10.5 9L10.5 15ZM22.06 7.17C22.19 7.64 22.28 8.27 22.34 9.07C22.41 9.87 22.44 10.56 22.44 11.16L22.5 12C22.5 14.19 22.34 15.8 22.06 16.83C21.81 17.73 21.23 18.31 20.33 18.56C19.86 18.69 19 18.78 17.68 18.84C16.38 18.91 15.19 18.94 14.09 18.94L12.5 19C8.31 19 5.7 18.84 4.67 18.56C3.77 18.31 3.19 17.73 2.94 16.83C2.81 16.36 2.72 15.73 2.66 14.93C2.59 14.13 2.56 13.44 2.56 12.84L2.5 12C2.5 9.81 2.66 8.2 2.94 7.17C3.19 6.27 3.77 5.69 4.67 5.44C5.14 5.31 6 5.22 7.32 5.16C8.62 5.09 9.81 5.06 10.91 5.06L12.5 5C16.69 5 19.3 5.16 20.33 5.44C21.23 5.69 21.81 6.27 22.06 7.17Z",
    fill: "#2F2D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiyoutube);
export default __webpack_public_path__ + "static/media/mdiyoutube.8bd62b800befc744fbfe12e49e10e3bd.svg";
export { ForwardRef as ReactComponent };